import React from 'react';
import PropTypes from 'prop-types';

const AppStore = ({ altText }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='1.5em' height='1.5em' fill='none'>
      <title id='app-store-title'>{altText}</title>
      <path fill='currentColor' fillRule='evenodd' d='M3.25 5.5A2.25 2.25 0 0 1 5.5 3.25h3a2.25 2.25 0 0 1 2.25 2.25v3a2.25 2.25 0 0 1-2.25 2.25h-3A2.25 2.25 0 0 1 3.25 8.5v-3Zm2.25-.75a.75.75 0 0 0-.75.75v3c0 .414.336.75.75.75h3a.75.75 0 0 0 .75-.75v-3a.75.75 0 0 0-.75-.75h-3ZM3.25 14.5a2.25 2.25 0 0 1 2.25-2.25h3a2.25 2.25 0 0 1 2.25 2.25v3a2.25 2.25 0 0 1-2.25 2.25h-3a2.25 2.25 0 0 1-2.25-2.25v-3Zm2.25-.75a.75.75 0 0 0-.75.75v3c0 .414.336.75.75.75h3a.75.75 0 0 0 .75-.75v-3a.75.75 0 0 0-.75-.75h-3ZM14.5 3.25a2.25 2.25 0 0 0-2.25 2.25v3a2.25 2.25 0 0 0 2.25 2.25h3a2.25 2.25 0 0 0 2.25-2.25v-3a2.25 2.25 0 0 0-2.25-2.25h-3Zm-.75 2.25a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1-.75-.75v-3Z' clipRule='evenodd'/>
      <path fill='currentColor' d='M17 13.25a.75.75 0 0 1 .75.75v2.25H20a.75.75 0 0 1 0 1.5h-2.25V20a.75.75 0 0 1-1.5 0v-2.25H14a.75.75 0 0 1 0-1.5h2.25V14a.75.75 0 0 1 .75-.75Z'/>
    </svg>
  );
};

AppStore.propTypes = {
  altText: PropTypes.string
};

export default AppStore;
